import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { ApiUrlHelper } from '../../../common/api-url-helper';
import { NgxSpinnerService } from 'ngx-spinner';
import { CommonService } from '../../../services/common/common.service';
import { ToastrService } from 'ngx-toastr';
import { TooltipConstants } from '../../../constants/message-constants';

@Component({
  selector: 'app-tooltip-modal',
  templateUrl: './tooltip-modal.component.html',
  styleUrl: './tooltip-modal.component.scss'
})
export class TooltipModalComponent {
  q_1:string = '';
  IsPreview:any;
  TooltipName:any
  public Editor = ClassicEditor;
  editorConfig = {
    toolbar: {
      items: [
        'undo', 'redo', '|', 'heading', '|', 'bold', 'italic', '|', 'link', '|', 'bulletedList', 'numberedList', '|', 'indent', 'outdent'
      ]
    },
    link: {
      addTargetToExternalLinks: true,
    },
    licenseKey: 'GPL'
  };
  constructor(@Inject(MAT_DIALOG_DATA)public data: { id: any,IsPreview:any,name:any},
    private readonly api: ApiUrlHelper,
    private readonly spinner: NgxSpinnerService,
    private readonly commonService: CommonService,
    private readonly toaster: ToastrService,){

  }
  ngOnInit(): void {
    this.IsPreview = this.data.IsPreview
    this.TooltipName =this.data.name
    this.fetchToolTipDetails(this.data.id);
  }
saveTooltip(){
  let api = this.api.apiUrl.Tooltip.SaveToolTip
    let model ={
      ToolTipId : this.data.id,
      Description : this.q_1
    }
    this.spinner.show();

    this.commonService.doPost(api, model).pipe().subscribe({
      next: (response:any) => {
        if (response.success) {
          this.toaster.success(this.data.name + ' ' + TooltipConstants.CommonTooltip);
        } else {
          this.toaster.error(response.message);
          }
          this.spinner.hide();
      },
      error: (err) => {
        console.log(err);
        this.spinner.hide();
      },
      complete: () => {
      },
    });
  }
  fetchToolTipDetails(id:any){
    let api = this.api.apiUrl.Tooltip.GetToolTip.replace(
      '{ToolTipId}',id
    );
   this.spinner.show();
    this.commonService
      .doGet(api)
      .pipe()
      .subscribe({
        next: (response) => {
          this.q_1 = response.data.description;
        this.spinner.hide();

        },
        error: (err) => {
          console.log(err);
          this.spinner.hide();
        },
        complete: () => {
        },
      });

  }
}
